import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { TextareaAutosizeP2 } from '../../styled/typography/typographyExtentions'

const textareaStyle = {
  width: '100%',
  minHeight: '80px',
  padding: '18px',
  marginTop: '10px',
  resize: 'none',
  border: '1px solid #ccc',
  borderRadius: '5px'
}

export default class TextFieldsStudent extends Component {

  state = {
    studentNote: null
  }

  constructor (props) {
    super(props)
    this.onBlurBound = this.onBlur.bind(this)
    this.onChangeBound = this.onChange.bind(this)
  }

  render () {
    return (
      <div style={{ textAlign: 'left' }}>
        <TextareaAutosizeP2
          id='mentor-student-feedback'
          style={textareaStyle}
          onBlur={this.onBlurBound}
          onChange={this.onChangeBound}
          placeholder='Give some examples to support your choice.'
        />
      </div>
    )
  }

  onBlur () {
    this.props.onStudentTextChange(this.state.studentNote, this.props.index)
  }

  onChange (e) {
    this.setState({
      studentNote: e.currentTarget.value
    })
  }
}

TextFieldsStudent.propTypes = {
  dispatch: PropTypes.func,
  index: PropTypes.number,
  onStudentTextChange: PropTypes.func
}
